<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-dialog v-model="cancelDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          {{ $t("globals.cancel_wizard") }}
        </v-card-title>
        <v-card-text>
          {{
            $t("If you exit the wizard any changes made so far will be lost")
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cancelDialog = false">
            {{ $t("globals.keep_working") }}
          </v-btn>
          <v-btn color="primary" text @click="cancelWizard()">
            {{ $t("globals.cancel_anyway") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog scrollable persistent v-model="dialogs.edit" max-width="1000">
      <material-card
        v-if="editedItem"
        :title="
          $t('views.insurancecarriers.edit_contact_info_for_{0}', [
            trans(editedItem.InsuranceCarrier, 'Name'),
          ])
        "
        icon="edit"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-row>
            <v-stepper
              v-model="e6"
              vertical
              class="elevation-0"
              style="width: 100%;"
            >
              <v-stepper-step :complete="e6 > 1" step="1" editable>
                {{
                  $t(
                    "views.insurancecarriers.insurance_carrier_contact_details"
                  )
                }}
                <small>
                  {{ $t("components.inmemorystores.fill_in_the_fields") }}
                </small>
              </v-stepper-step>
              <v-stepper-content step="1">
                <div row justify-center>
                  <v-form
                    v-if="editedItem !== null && editedItem !== undefined"
                    ref="detailsForm"
                    v-model="detailsValid"
                  >
                    <v-container fluid grid-list-md>
                      <v-row>
                        <v-col xs="12" sm="6" md="4">
                          <!-- <no-autocomplete-textfield
                            v-model="editedItem.PhoneNumber"
                            :label="$t('globals.telephone')"
                            :rules="[rules.phone]"
                            v-mask="telephoneMask"
                          ></no-autocomplete-textfield> -->
                          <no-autocomplete-textfield
                            v-model="editedItem.PhoneNumber"
                            :label="$t('globals.telephone')"
                            :rules="[$rules.phone]"
                          ></no-autocomplete-textfield>
                        </v-col>
                        <v-col xs="12" sm="6" md="4">
                          <!-- <no-autocomplete-textfield
                            v-model="editedItem.Fax"
                            :label="$t('globals.fax_number')"
                            :rules="[rules.phone]"
                            v-mask="telephoneMask"
                          ></no-autocomplete-textfield> -->
                          <no-autocomplete-textfield
                            v-model="editedItem.Fax"
                            :label="$t('globals.fax_number')"
                            :rules="[$rules.phone]"
                          ></no-autocomplete-textfield>
                        </v-col>
                        <v-col xs="12" sm="6" md="4">
                          <no-autocomplete-textfield
                            v-model="editedItem.Email"
                            :label="$t('headers.contacts.email')"
                            :rules="[$rules.email]"
                          ></no-autocomplete-textfield>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </div>
                <v-btn
                  color="primary"
                  @click="continueToAddress()"
                  :disabled="!detailsValid"
                >
                  {{ $t("globals.continue") }}
                </v-btn>
              </v-stepper-content>

              <v-stepper-step :complete="e6 > 2" step="2" editable>
                {{ $t("views.insurancecarriers.insurance_carrier_address") }}
                <small>
                  {{
                    $t(
                      "views.insurancecarriers.add_address_to_this_insurance_carrier"
                    )
                  }}
                </small>
              </v-stepper-step>
              <v-stepper-content step="2">
                <v-container>
                  <!-- <address-form
                    ref="address"
                    :provinces="provinces"
                    :item="editedItem"
                  ></address-form> -->
                  <canada-post-address
                    :address="editedItem.Address"
                    @update-address="editedItem.Address = $event"
                    @valid="validAddress = $event"
                  />
                </v-container>
                <v-btn text @click="addressBack()">
                  {{ $t("globals.back") }}
                </v-btn>
                <v-btn color="primary" @click="e6 = 3" :disabled="!validAddress">
                  {{ $t("globals.continue") }}
                </v-btn>
              </v-stepper-content>

              <v-stepper-step :complete="e6 > 3" step="3" editable>
                {{ $t("views.insurancecarriers.add_contacts") }}
                <small>
                  {{
                    $t(
                      "views.insurancecarriers.add_one_or_more_contacts_to_this_insurance_carrier"
                    )
                  }}
                </small>
              </v-stepper-step>

              <v-stepper-content step="3">
                <in-memory-contacts
                  @contactsChanged="contactsChanged($event)"
                  :contacts="editedContacts"
                  identifier="insuranceCarrierEditContacts"
                ></in-memory-contacts>
                <v-btn text @click="e6 = 2">
                  {{ $t("globals.back") }}
                </v-btn>
              </v-stepper-content>
            </v-stepper>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cancelDialog = true">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!allValid()"
            color="primary"
            :loading="saving"
            @click="update"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable persistent v-model="dialogs.policy" max-width="1000">
      <material-card
        v-if="editedItem"
        :title="
          $t('views.insurancecarriers.edit_policy_for_{0}', [
            trans(editedItem.InsuranceCarrier, 'Name'),
          ])
        "
        icon="edit"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-title></v-card-title>
        <v-card-text>
          <v-dialog v-model="cancelPolicyDialog" persistent max-width="400">
            <v-card>
              <v-card-title class="headline">
                {{ $t("globals.cancel_wizard") }}
              </v-card-title>
              <v-card-text>
                {{
                  $t(
                    "If you exit the wizard any changes made so far will be lost"
                  )
                }}
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="cancelPolicyDialog = false">
                  {{ $t("globals.keep_working") }}
                </v-btn>
                <v-btn color="primary" text @click="cancelPolicyWizard()">
                  {{ $t("globals.cancel_anyway") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-row v-if="dialogs.policy">
            <v-stepper v-model="e6" vertical class="elevation-0">
              <v-stepper-step :complete="e6 > 1" step="1" editable>
                {{ $t("components.memberview.select_effective_date") }}
                <small>{{ $t("views.insurancecarriers.pick_a_date") }}</small>
              </v-stepper-step>
              <v-stepper-content step="1">
                <div row justify-center>
                  <v-form v-model="effectiveDateValid" ref="effectiveDateForm">
                    <v-row>
                      <v-col>
                        <pbas-date-picker
                          :value="effectiveDate"
                          @update-date="effectiveDate = $event"
                          :label="$t('components.inmemorydependants.effective_date')"
                          :rules="[$rules.required, $rules.firstRenewalDate]"
                          :allowedDates="allowedDates"
                          class="required"
                        ></pbas-date-picker>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-btn
                  color="primary"
                  @click="e6 = 2"
                  :disabled="!effectiveDateValid"
                >
                  {{ $t("globals.continue") }}
                </v-btn>
              </v-stepper-content>

              <v-stepper-step :complete="e6 > 2" step="2" editable>
                {{ $t("views.insurancecarriers.insurance_carrier_policy") }}
                <small>
                  {{ $t("components.inmemorystores.fill_in_the_fields") }}
                </small>
              </v-stepper-step>
              <v-stepper-content step="2">
                <div row justify-center>
                  <v-form ref="policyForm" v-model="policyValid">
                    <v-container fluid grid-list-md>
                      <v-row>
                        <v-col xs="12" sm="6" md="6">
                          <no-autocomplete-textfield
                            v-model="editedItem.PolicyIdentity.Number"
                            :label="$t('globals.policy_number')"
                            :rules="[$rules.required]"
                            class="required"
                          ></no-autocomplete-textfield>
                        </v-col>
                        <v-col xs="12" sm="6" md="6">
                          <trans-select
                            :item="editedItem.PolicyIdentity"
                            propertyName="Status"
                            :items="statuses"
                            :label="$t('globals.status')"
                            :rules="[$rules.required]"
                            class="required"
                          ></trans-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </div>
                <v-btn text @click="e6 = 1">
                  {{ $t("globals.back") }}
                </v-btn>
              </v-stepper-content>
            </v-stepper>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cancelPolicyDialog = true">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!effectiveDateValid || !policyValid"
            color="primary"
            :loading="saving"
            @click="updatePolicy"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <material-card
    :title="$t('globals.insurance_carriers')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="home_work"
    >
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        fileNamePrefix="insurance-carriers"
        @itemsChanged="setData($event)"
        :exporters="$exporters"
        identifier="insuranceCarriersTable"
        :canExpand="(item) => item.PolicyIdentity.HasHistory"
        :showExpand="true"
        :generateProviderForExpanded="
          (item) => generateProvider(item, 'insuranceCarriers', historyHeaders)
        "
        @error="error = $event"
      ></pbas-data-table>
    </material-card>
    <contacts
      ref="contacts"
      entity="InsuranceCarrier"
      filter="PlanInsuranceCarrierId ne null"
      :relatedHeaders="insuranceCarrierContactHeaders"
      @refresh="$refs.table.getDataAsync()"
      identifier="insuranceCarrierContacts"
    ></contacts>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Contacts from "../components/Contacts";
import InMemoryContacts from "../components/InMemoryContacts";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import InsuranceCarriersHeaders from "../headers/InsuranceCarriers";
import InsuranceCarriersHistoryHeaders from "../headers/InsuranceCarriersHistory";
import { ODataHeader, ODataString } from "pbas-vue-components";
import TransSelect from "../components/TransSelect";
import { locker } from "../mixins/locker";
import { translate2 } from "../trans2";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { planSetter } from "../mixins/planSetter";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import CanadaPostAddress from "@/components/CanadaPostAddress";

export default {
  name: "insurance-carriers-table",
  components: {
    Contacts,
    InMemoryContacts,
    ErrorHandler,
    TransSelect,
    NoAutocompleteTextfield,
    CanadaPostAddress,
  },
  mixins: [locker, planSetter],
  directives: { mask },
  data() {
    return {
      postalCodeMask: "A#A #A#",
      telephoneMask: "(###) ### - ####",
      rules: {
        phone: (v) => {
          let val = this.unmask(v, this.telephoneMask);
          return !val || this.$rules.phone(val);
        },
      },
      editedItemId: null,
      effectiveDate: null,
      effectiveDateValid: true,
      policyValid: true,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      insuranceCarrierContactHeaders: [
        new ODataHeader({
          type: new ODataString("PlanInsuranceCarrier/InsuranceCarrier/Name"),
          sortable: true,
          visible: false,
          searchable: true,
          version: 1,
          allowVisibilityChange: false,
        }),
        new ODataHeader({
          title: "globals.insurance_carrier",
          type: new ODataString(
            "PlanInsuranceCarrier/InsuranceCarrier/Translations[]/Name",
            {
              getString: (item) =>
                translate2(item.PlanInsuranceCarrier.InsuranceCarrier, "Name"),
            }
          ),
          sortable: true,
          visible: true,
          searchable: true,
          version: 1,
          orderByKey: "InsuranceCarrier/Name",
        }),
        new ODataHeader({
          type: new ODataString(
            "PlanInsuranceCarrier/InsuranceCarrier/Translations[]/LanguageCode"
          ),
          sortable: false,
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          title: "Insurance Carrier Id",
          type: new ODataString("PlanInsuranceCarrier/Id"),
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          title: "Insurance CarrierId",
          type: new ODataString("PlanInsuranceCarrierId"),
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
      ],
      detailsValid: true,
      contactValidList: [],
      contactvalid: true,
      defaultContact: {
        Name: "",
        Email: "",
        Status: null,
      },
      contact: {},
      cancelDialog: false,
      cancelPolicyDialog: false,
      provinces: [],
      provider: undefined,
      saving: false,
      statuses: [],
      rowActions: [
        {
          name: "editDetails",
          icon: "edit",
          title: "views.insurancecarriers.edit_contact_info",
          handler: (item) => this.editItem(item),
          visible: (item) => !this.selectedPlan.Current.IsTesting,
        },
        {
          name: "editPolicy",
          icon: "edit",
          title: "views.insurancecarriers.edit_policy",
          handler: (item) => this.editPolicy(item),
          visible: (item) => !this.selectedPlan.Current.IsTesting,
        },
      ],
      e6: 1,
      dialogs: {
        edit: false,
        policy: false,
      },
      insuranceCarriers: [],
      planInsuranceCarriers: [],
      headers: InsuranceCarriersHeaders,
      historyHeaders: InsuranceCarriersHistoryHeaders,
      editedIndex: -1,
      editedItem: null,
      editedContacts: [],
      defaultItem: {
        Name: "",
        Status: null,
        InsuranceCarrier: {},
        PolicyIdentity: {
          Current: {},
        },
      },
      error: null,
      validAddress: true
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", { columnsDropDownOptions: "options" }),
    ...mapGetters("plansMembers", { planIdentity: "planIdentity" }),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["settings"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
    effectiveDate: {
      handler(v) {
        if (v) {
          this.loadDateDepended(v);
        }
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "updateInsuranceCarrier",
      "updateInsuranceCarrierPolicy",
      "getPolicyByEffectiveDate",
      "getInsuranceCarrier",
      "getAllInsuranceCarriers",
    ]),
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    trans(item, field) {
      //console.log(item)
      return translate2(item, field);
    },
    generateProvider(item, entity, headers, query) {
      let url =
        "plans/" +
        this.selectedPlan.Id +
        "/" +
        entity +
        "/" +
        item.Id +
        "/history";
      if (query) {
        url += "?" + query;
      }
      return new PbasOData(
        this.$axiosHttp,
        url,
        headers.filter(
          (o) =>
            (o.visible === true && o.allowVisibilityChange === true) ||
            o.allowVisibilityChange === false
        )
      );
    },
    allowedDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.planIdentity.FirstRenewalDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    async loadDateDepended(date) {
      try {
        this.editedItem.PolicyIdentity = await this.lock(
          this.getPolicyByEffectiveDate,
          {
            plan: this.selectedPlan.Id,
            id: this.editedItemId,
            date: date,
            dialogs: this.dialogs,
            dialog: "policy",
          },
          () => {
            this.dialogs.policy = false;
          }
        );

        if (typeof this.editedItem.PolicyIdentity !== "object") {
          let error = new Error();
          error.clientCode = "insuranceCarriersNoPolicy";
          this.error = error;
          return;
        }

        //console.log(this.editedItem);

        this.editedItem.PolicyIdentity.EffectiveDate = date;
      } catch (error) {
        this.error = error;
      }
    },
    continueToAddress() {
      // if (this.$refs.address) {
      //   this.$refs.address.validate();
      // }
      this.e6 = 2;
    },
    addressBack() {
      // if (this.$refs.address) {
      //   this.$refs.address.resetValidation();
      // }
      this.e6 = 1;
    },
    contactsChanged(items) {
      this.editedContacts = items;
    },
    // addressValid() {
    //   return (
    //     this.$refs.address &&
    //     (this.$refs.address.valid || !this.$refs.address.dirty)
    //   );
    // },
    allValid() {
      if (!this.editedItem) return false;
      return this.detailsValid && this.validAddress;
    },
    cancelWizard() {
      this.cancelDialog = false;
      this.e6 = 1;
      this.close();
    },
    cancelPolicyWizard() {
      this.cancelPolicyDialog = false;
      this.e6 = 1;
      this.closePolicy();
    },
    async loadPlanData() {
      // try {
      this.provinces = this.columnsDropDownOptions.Models.Province;

      this.statuses = this.columnsDropDownOptions.Models.Status;

      this.columnsOptions = {
        statuses: this.statuses,
      };
      // this.$refs.contacts.displayFunctions.insuranceCarrierDisplayFunc = (
      //   item
      // ) => item.InsuranceCarrier.Name;

      // this.$nextTick(() => {

      //   console.log("load data 2", this.provider);
      // });
      let url = "plans/" + this.selectedPlan.Id + "/insuranceCarriers";
      this.provider = new PbasOData(this.$axiosHttp, url, this.headers);
      // } catch (error) {
      //   this.error = error;
      // }
    },
    setData(items) {
      for (let item of items) {
        item.Name = item.InsuranceCarrier.Name;
      }
      this.planInsuranceCarriers = items;
    },
    setSelectedCoverages() {
      this.$refs.coveragesTable.selected = this.editedItem.Coverage;
    },
    async editItem(item) {
      const editedIndex = this.planInsuranceCarriers.indexOf(item);
      try {
        this.editedItem = await this.lock(
          this.getInsuranceCarrier,
          {
            id: item.Id,
            plan: this.selectedPlan.Id,
            dialogs: this.dialogs,
            dialog: "edit",
          },
          () => {
            this.dialogs.edit = false;
          }
        );

        this.editedContacts = JSON.parse(JSON.stringify(item.Contacts));
        if (!this.editedItem.Address) this.editedItem.Address = {};
        //console.log(this.editedItem);
        this.dialogs.edit = true;
        this.editedIndex = editedIndex;
        this.$refs.contacts.loadPlanData();
      } catch (error) {
        this.error = error;
      }
    },
    async editPolicy(item) {
      this.editedItemId = item.Id;
      this.editedIndex = this.planInsuranceCarriers.indexOf(item);
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.dialogs.policy = true;
    },
    close() {
      this.dialogs.edit = false;
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.editedIndex = -1;
      if (this.$refs.address) this.$refs.address.resetValidation();
      if (this.$refs.detailsForm) this.$refs.detailsForm.resetValidation();
      this.editedContacts = [];
      this.$refs.contacts.reload();
      this.e6 = 1;
    },
    closePolicy() {
      this.dialogs.policy = false;
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.editedIndex = -1;
      this.editedItemId = null;
      if (this.$refs.policyForm) this.$refs.policyForm.resetValidation();
      this.$refs.effectiveDateForm.resetValidation();
      this.e6 = 1;
      this.effectiveDate = null;
    },
    async update() {
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.editedItem));
        delete item.Status;
        delete item.StatusId;
        delete item.Coverage;
        delete item.InsuranceCarrier;
        delete item.PolicyIdentity;
        if (item.Address) {
          if (item.Address.Province) {
            item.Address.ProvinceId = item.Address.Province.Id;
            delete item.Address.Province;
            // if (item.Address.StreetNumber)
            //   item.Address.StreetNumber = parseInt(item.Address.StreetNumber);
            // else delete item.Address.StreetNumber;
            item.Address.PlanInsuranceCarrierId = item.Id;
            if (item.Address.Country) {
              item.Address.CountryId = item.Address.Country.Id;
              delete item.Address.Country;
            }
          } else {
            delete item.Address;
          }
        }
        item.Contacts = JSON.parse(JSON.stringify(this.editedContacts));
        if (item.Contacts) {
          item.Contacts.forEach((contact) => {
            if (contact.Status) contact.StatusId = contact.Status.Id;
            else contact.StatusId = null;
            delete contact.Status;
            contact.PlanIdentityId = this.selectedPlan.Id;
            contact.PlanInsuranceCarrierId = item.Id;
            if (contact.Title !== null && contact.Title !== undefined) {
              contact.TitleId = contact.Title.Id;
              delete contact.Title;
            }
            if (
              contact.PhoneNumber !== null &&
              contact.PhoneNumber !== undefined
            ) {
              contact.PhoneNumber = this.unmask(
                contact.PhoneNumber,
                this.telephoneMask
              );
            }
            if (contact.Fax !== null && contact.Fax !== undefined) {
              contact.Fax = this.unmask(contact.Fax, this.telephoneMask);
            }
          });
        }
        await this.updateInsuranceCarrier({
          plan: this.selectedPlan.Id,
          insuranceCarrier: item,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.close();
        this.$refs.table.getDataAsync();
        this.$refs.contacts.reload();
        this.editedContacts = [];
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async updatePolicy() {
      this.saving = true;
      try {
        //console.log(this.editedItem);
        let item = {
          Id: this.editedItem.Id,
          Name: this.editedItem.InsuranceCarrier.Name,
          Policy: JSON.parse(JSON.stringify(this.editedItem.PolicyIdentity)),
        };
        delete item.Policy["@odata.context"];
        delete item.Policy["@odata.type"];

        item.Policy.PlanInsuranceCarrierId = item.Id;

        if (item.Policy.Status) item.Policy.StatusId = item.Policy.Status.Id;
        else item.Policy.StatusId = null;
        delete item.Policy.Status;

        await this.updateInsuranceCarrierPolicy({
          plan: this.selectedPlan.Id,
          insuranceCarrier: item,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.closePolicy();
        this.$refs.table.getDataAsync();
        this.$refs.contacts.reload();
        this.editedContacts = [];
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
  },
};
</script>
